import type { SidebarNavigationItem } from "@/routing/adminRoutes";

/**
 * Spoof pages show live customer identities, so screenshot mode keeps them
 * out of the sidebar, search and Pinned.
 */
export const SCREENSHOT_UNSAFE_NAVIGATION_PATHS: ReadonlySet<string> = new Set([
  "/spoof",
  "/advanced-spoof",
  "/spoof-sessions",
  "/spoof-launcher",
]);

export const filterScreenshotSafeNavigationItems = (
  items: SidebarNavigationItem[],
): SidebarNavigationItem[] =>
  items.flatMap((item) => {
    if (item.path && SCREENSHOT_UNSAFE_NAVIGATION_PATHS.has(item.path)) {
      return [];
    }

    if (!item.children?.length) {
      return [item];
    }

    const children = filterScreenshotSafeNavigationItems(item.children);
    return children.length === 0 && !item.path ? [] : [{ ...item, children }];
  });
